import { motion } from 'framer-motion';

interface WelcomePanelProps {
  readonly onClose: () => void;
}

export function WelcomePanel({ onClose }: WelcomePanelProps) {
  return (
    <motion.section
      className="glass-panel w-[min(34rem,100%)] rounded-lg p-6 text-center"
      initial={{ y: 18, scale: 0.98 }}
      animate={{ y: 0, scale: 1 }}
      exit={{ y: 18, scale: 0.98 }}
    >
      <div className="mx-auto mb-4 grid size-16 place-items-center rounded-md bg-hive-honey font-display text-3xl font-bold text-hive-ink">
        BH
      </div>
      <h1 className="font-display text-3xl font-bold md:text-4xl">The Bee&apos;s Hive</h1>
      <p className="mx-auto mt-3 max-w-md text-sm font-medium text-hive-ink/70">
        A cozy British town grown from quiet fields into a living miniature community.
      </p>
      <button type="button" className="hive-button hive-button-primary mt-6" onClick={onClose}>
        Begin
      </button>
    </motion.section>
  );
}
